import React, { Component } from 'react';
import { Dropdown, Button, Menu, Icon } from 'antd';
import UserIcon from '../../images/user-avatar.svg';
import { FormattedMessage } from 'react-intl';
import cw from '../../utils/commonwords';

export class HeaderUserDropdown extends Component {
  handleMenuDropDownSelect = e => {
    const { signOutUser } = this.props;

    switch (e.key) {
      case 'signout':
        signOutUser();
        break;

      default:
        break;
    }
  };
  render() {
    const { intl } = this.props;
    const menu = (
      <Menu onClick={this.handleMenuDropDownSelect}>
        <Menu.Item key="signout">
          <FormattedMessage id="App.Auth.signOut" defaultMessage={'Sign Out'} />
        </Menu.Item>
      </Menu>
    );
    return (
      <Dropdown overlay={menu} trigger={['click']}>
        <Button type="link">
          <img src={UserIcon} alt={intl.formatMessage(cw.userIcon)} />{' '}
          <Icon type="down" />
        </Button>
      </Dropdown>
    );
  }
}

export default HeaderUserDropdown;
